import { Component, Input, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-payment-otd-btn',
  templateUrl: './payment-otd-btn.component.html',
  styleUrls: ['./payment-otd-btn.component.scss']
})
export class PaymentOtdBtnComponent implements OnInit {

  @Input() config;

  constructor(
    public sheet: MatBottomSheet
  ) { }

  ngOnInit(): void {
  }

  openSheet(template) {
    this.sheet.open(template, {
      panelClass: 'payment-sheet'
    });
  }

}
